// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/images/home/compliance-header-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/images/home/operations-bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/images/home/hero-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/images/home/compliance-header-mobile-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compliance-page .home-page-content .simplify-compliance {
  display: flex;
  margin-top: 22px;
  height: 530px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  border-radius: 20px;
}
.compliance-page .home-page-content .simplify-compliance .simplify-compliance-left {
  width: 47%;
  height: 100%;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  padding: 100px 0 100px 100px;
  color: #fff;
}
.compliance-page .home-page-content .simplify-compliance .simplify-compliance-left .simplify-compliance-title {
  font-size: 48px;
  font-weight: 600;
  line-height: 120%;
}
.compliance-page .home-page-content .simplify-compliance .simplify-compliance-left .simplify-compliance-title .blue-part {
  color: #a5c7ff;
}
.compliance-page .home-page-content .simplify-compliance .simplify-compliance-left .simplify-compliance-subtitle {
  font-size: 22px;
  margin-top: 24px;
  line-height: 180%;
}
.compliance-page .home-page-content .simplify-compliance .simplify-compliance-left .request-demo-btn {
  margin-top: 46px;
  background-color: #fff;
  border: none;
  border-bottom: 2px solid #dee1e7;
  border-radius: 8px;
  padding: 12px 24px 12px 24px;
  gap: 8px;
  display: flex;
  align-items: center;
  width: 200px;
  height: 46px;
  color: #448aff;
  font-weight: 600;
  box-shadow: 0px 6px 10px -4px rgba(15, 23, 40, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(15, 23, 40, 0.2196078431);
}
.compliance-page .home-page-content .simplify-compliance .simplify-compliance-right {
  height: 100%;
  position: relative;
  width: 57%;
}
.compliance-page .home-page-content .simplify-compliance .simplify-compliance-right .simplify-compliance-image {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
.compliance-page .home-page-content .simplify-compliance .simplify-compliance-right::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: linear-gradient(90deg, #3571d6 0%, rgba(53, 113, 214, 0) 39.9%);
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  pointer-events: none;
}
.compliance-page .home-page-content .manual-process {
  padding: 120px 100px;
  display: flex;
}
.compliance-page .home-page-content .manual-process .manual-process-left-block {
  padding: 44px 32px 44px 0;
  width: 44%;
  display: flex;
  align-items: center;
}
.compliance-page .home-page-content .manual-process .manual-process-left-block .say-goodbye-title {
  color: #448aff;
  font-weight: 400;
  font-size: 40px;
  line-height: 120%;
}
.compliance-page .home-page-content .manual-process .manual-process-left-block .say-goodbye-subtitle {
  margin-top: 20px;
  font-weight: 400;
  font-size: 20px;
  line-height: 180%;
}
.compliance-page .home-page-content .manual-process .manual-process-right-block {
  width: 56%;
}
.compliance-page .home-page-content .manual-process .manual-process-right-block .manual-process-list {
  width: 100%;
}
.compliance-page .home-page-content .manual-process .manual-process-right-block .manual-process-list .manual-process-list-item {
  min-height: 60px;
  padding: 12px 24px;
  border-left: 2px solid #a5c7ff;
  background: linear-gradient(90deg, #e7f0ff 0%, #ffffff 100%);
  margin-top: 12px;
  font-size: 20px;
  font-weight: 600;
  line-height: 180%;
  color: #040e46;
}
.compliance-page .home-page-content .manual-process .manual-process-right-block .manual-process-list .manual-process-list-item:nth-child(1) {
  margin-top: 0;
}
.compliance-page .home-page-content .manual-process .manual-process-right-block .manual-process-list .manual-process-list-item:nth-child(2) {
  margin-right: 68px;
  margin-left: 30px;
}
.compliance-page .home-page-content .manual-process .manual-process-right-block .manual-process-list .manual-process-list-item:nth-child(3) {
  margin-right: 38px;
  margin-left: 60px;
}
.compliance-page .home-page-content .manual-process .manual-process-right-block .manual-process-list .manual-process-list-item:nth-child(4) {
  margin-right: 8px;
  margin-left: 90px;
}
.compliance-page .home-page-content .compliance-core-capabilities {
  padding: 80px;
  background-color: #e7f0ff;
  border: 1px solid #eceef1;
  border-radius: 20px;
}
.compliance-page .home-page-content .compliance-core-capabilities .core-capabilities-title {
  font-size: 40px;
  line-height: 120%;
  color: #3571d6;
  text-align: center;
}
.compliance-page .home-page-content .compliance-core-capabilities .core-capabilities-grid-container {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 32px;
  margin-top: 46px;
}
.compliance-page .home-page-content .compliance-core-capabilities .core-capabilities-grid-container .core-capabilities-item {
  position: relative;
  min-height: 260px;
  padding: 112px 36px 36px 36px;
  grid-column: span 4;
  background: linear-gradient(0deg, var(--Greyscale-Grey-5, #f9fafb), var(--Greyscale-Grey-5, #f9fafb)), radial-gradient(50% 161.19% at 50% 100%, rgba(68, 138, 255, 0) 50%, rgba(68, 138, 255, 0.1) 100%);
}
.compliance-page .home-page-content .compliance-core-capabilities .core-capabilities-grid-container .core-capabilities-item.core-capabilities-item-tall {
  grid-row: span 2;
}
.compliance-page .home-page-content .compliance-core-capabilities .core-capabilities-grid-container .core-capabilities-item.core-capabilities-item-wide {
  grid-column: span 8;
}
.compliance-page .home-page-content .compliance-core-capabilities .core-capabilities-grid-container .core-capabilities-item.core-capabilities-item-semi-wide {
  grid-column: span 6;
}
.compliance-page .home-page-content .compliance-core-capabilities .core-capabilities-grid-container .core-capabilities-item .corner-image-wrapper {
  position: absolute;
  right: 0;
  top: 0;
  text-align: right;
}
.compliance-page .home-page-content .compliance-core-capabilities .core-capabilities-grid-container .core-capabilities-item .corner-image-wrapper svg {
  position: absolute;
  top: 42px;
  right: 42px;
}
.compliance-page .home-page-content .compliance-core-capabilities .core-capabilities-grid-container .core-capabilities-item .core-capabilities-item-screenshot-img {
  width: 100%;
  height: 260px;
  background-size: cover;
  position: relative;
  z-index: 2;
  object-fit: cover;
  border-radius: 4px;
}
.compliance-page .home-page-content .compliance-core-capabilities .core-capabilities-grid-container .core-capabilities-item .core-capabilities-item-screenshot-img.capabilities-drill-screenshot {
  object-position: 0 -150px;
}
.compliance-page .home-page-content .compliance-core-capabilities .core-capabilities-grid-container .core-capabilities-item .core-capabilities-item-content {
  position: relative;
}
.compliance-page .home-page-content .compliance-core-capabilities .core-capabilities-grid-container .core-capabilities-item .core-capabilities-item-content .core-capabilities-item-title {
  color: #040e46;
  font-size: 26px;
  font-weight: 600;
  line-height: 130%;
}
.compliance-page .home-page-content .compliance-core-capabilities .core-capabilities-grid-container .core-capabilities-item .core-capabilities-item-content .core-capabilities-item-subtitle {
  margin-top: 12px;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
}
.compliance-page .home-page-content .compliance-core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(3) {
  padding: 6px;
}
.compliance-page .home-page-content .compliance-core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(3) .corner-image-wrapper {
  top: 215px;
}
.compliance-page .home-page-content .compliance-core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(3) .core-capabilities-item-content {
  margin-top: 112px;
  margin-left: 36px;
  margin-right: 36px;
}
.compliance-page .home-page-content .compliance-core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(4) {
  padding: 6px;
  display: flex;
  gap: 32px;
}
.compliance-page .home-page-content .compliance-core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(4) .core-capabilities-item-screenshot-wrapper {
  width: calc(50% - 16px);
}
.compliance-page .home-page-content .compliance-core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(4) .core-capabilities-item-content {
  margin-top: 112px;
  margin-left: 36px;
  margin-right: 36px;
}
.compliance-page .home-page-content .compliance-core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(4) .core-capabilities-item-right-block {
  width: calc(50% - 16px);
}
.compliance-page .home-page-content .compliance-see-in-action {
  background-color: #3571d6;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  padding: 60px;
  border-radius: 20px;
  background-size: cover;
  margin-top: 20px;
  padding: 100px 100px 120px 100px;
}
.compliance-page .home-page-content .compliance-see-in-action .see-in-action-title {
  font-size: 40px;
  font-weight: 400;
  color: #fff;
  text-align: center;
}
.compliance-page .home-page-content .compliance-see-in-action .see-in-action-images-wrapper {
  display: flex;
  gap: 32px;
  margin-top: 80px;
}
.compliance-page .home-page-content .compliance-see-in-action .see-in-action-images-wrapper .see-in-action-image-wrapper {
  flex: 1 1;
  max-width: 276px;
  position: relative;
}
.compliance-page .home-page-content .compliance-see-in-action .see-in-action-images-wrapper .see-in-action-image-wrapper .see-in-action-img {
  width: 100%;
  height: 100%;
  max-height: 276px;
  object-fit: cover;
  border-radius: 10px;
}
.compliance-page .home-page-content .compliance-see-in-action .see-in-action-images-wrapper .see-in-action-image-wrapper .scale-icon {
  position: absolute;
  bottom: -41px;
  right: -22px;
}
.compliance-page .home-page-content .compliance-see-in-action .see-in-action-images-wrapper .see-in-action-image-wrapper:nth-child(1) .see-in-action-img {
  object-position: 0px -35px;
}
.compliance-page .home-page-content .compliance-see-in-action .see-in-action-images-wrapper .see-in-action-image-wrapper:nth-child(3) .see-in-action-img {
  object-position: left;
}
.compliance-page .home-page-content .compliance-core-benefits {
  padding: 135px 100px 80px 100px;
  width: 100%;
  margin-top: 20px;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  z-index: 1;
  border: 1px solid #eceef1;
}
.compliance-page .home-page-content .compliance-core-benefits::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.35;
  z-index: 0;
  border-radius: 20px;
  mix-blend-mode: luminosity;
}
.compliance-page .home-page-content .compliance-core-benefits .compliance-core-benefits-title {
  color: #000;
  font-size: 40px;
  text-align: center;
}
.compliance-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider {
  margin-top: 80px;
}
.compliance-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .swiper {
  padding-bottom: 3rem;
}
.compliance-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .swiper .swiper-button-next,
.compliance-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .swiper .swiper-button-prev {
  display: none;
}
.compliance-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .swiper .swiper-pagination-bullet {
  background: #fff;
  width: 10px;
  height: 10px;
  opacity: 1;
}
.compliance-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .swiper .swiper-pagination-bullet-active {
  background: #4b6fff;
}
.compliance-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .custom-nav {
  display: flex;
  justify-content: space-between;
}
.compliance-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .custom-nav button {
  position: relative;
  z-index: 10;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s;
  color: #3571d6;
}
.compliance-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .custom-nav button:hover {
  background-color: #f5f5f5;
}
.compliance-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .compliance-core-benefits-slide {
  position: relative;
  border-radius: 1rem;
  text-align: center;
  height: 230px;
}
.compliance-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .compliance-core-benefits-slide .compliance-core-benefits-slide-content {
  background-color: #fff;
  border-radius: 10px;
  height: 200px;
  padding: 80px 28px;
}
.compliance-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .compliance-core-benefits-slide .compliance-core-benefits-slide-content .compliance-core-benefits-title {
  color: #3571d6;
  font-size: 28px;
  font-weight: 600;
  line-height: 130%;
}
.compliance-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .compliance-core-benefits-slide .icon-wrapper {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  height: 90px;
  width: 90px;
  background-color: #3571d6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.compliance-page.isMobile .home-page-content .simplify-compliance {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: cover;
  margin-top: 37px;
  height: unset;
}
.compliance-page.isMobile .home-page-content .simplify-compliance .simplify-compliance-left {
  padding: 0 20px 20px 20px;
  margin-top: 240px;
  width: 100%;
}
.compliance-page.isMobile .home-page-content .simplify-compliance .simplify-compliance-left .simplify-compliance-title {
  font-size: 32px;
}
.compliance-page.isMobile .home-page-content .simplify-compliance .simplify-compliance-left .simplify-compliance-subtitle {
  font-size: 20px;
  margin-top: 16px;
  line-height: 160%;
}
.compliance-page.isMobile .home-page-content .simplify-compliance .simplify-compliance-left .request-demo-btn {
  margin-top: 28px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 150%;
}
.compliance-page.isMobile .home-page-content .manual-process {
  padding: 40px 20px 40px 20px;
  display: block;
}
.compliance-page.isMobile .home-page-content .manual-process .manual-process-left-block {
  width: 100%;
  padding: 0;
}
.compliance-page.isMobile .home-page-content .manual-process .manual-process-left-block .say-goodbye-title {
  font-weight: 400;
  font-size: 32px;
  line-height: 120%;
}
.compliance-page.isMobile .home-page-content .manual-process .manual-process-right-block {
  margin-top: 18px;
  width: 100%;
}
.compliance-page.isMobile .home-page-content .manual-process .manual-process-right-block .manual-process-list .manual-process-list-item {
  font-weight: 600;
  font-size: 18px;
  line-height: 120%;
  min-height: unset;
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-top: 10px !important;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities {
  padding: 40px 20px;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-title {
  font-size: 32px;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper {
  margin-top: 46px;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row .core-capabilities-col {
  padding: 6px;
  display: flex;
  gap: 8px;
  position: relative;
  background: radial-gradient(100% 157.58% at 0% 100%, rgba(68, 138, 255, 0.1) 0%, rgba(68, 138, 255, 0) 50%), linear-gradient(0deg, var(--Greyscale-Grey-5, #f9fafb), var(--Greyscale-Grey-5, #f9fafb));
  border: 1px solid #f9fafb;
  border-radius: 10px;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row .core-capabilities-col .core-capabilities-item-screenshot-wrapper .core-capabilities-item-screenshot-img {
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #fff;
  box-shadow: 0px 6px 10px -4px rgba(15, 23, 40, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(15, 23, 40, 0.2196078431);
  width: 130px;
  height: 132px;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row .core-capabilities-col .corner-image-wrapper {
  width: 100%;
  position: absolute;
  top: 0;
  right: 0;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row .core-capabilities-col .corner-image-wrapper .corner-image {
  width: 100%;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row .core-capabilities-col .core-capabilities-item-content {
  flex-grow: 1;
  padding: 74px 12px 12px 12px;
  position: relative;
  z-index: 2;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row .core-capabilities-col .core-capabilities-item-content .core-capabilities-item-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 130%;
  color: #040e46;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row .core-capabilities-col .core-capabilities-item-content .core-capabilities-item-subtitle {
  margin-top: 6px;
  font-weight: 400;
  font-size: 14px;
  line-height: 130%;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row.core-capabilities-row-1 {
  margin-top: 18px;
  display: flex;
  gap: 18px;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row.core-capabilities-row-1 .core-capabilities-col {
  width: 50%;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row.core-capabilities-row-1 .core-capabilities-col .core-capabilities-item-content {
  padding-top: 48px;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row.core-capabilities-row-2 {
  margin-top: 18px;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row.core-capabilities-row-2 .core-capabilities-item-content {
  position: static;
  padding-top: 36px;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row.core-capabilities-row-2 .corner-image-wrapper {
  width: 50%;
  top: 0;
  right: 0;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row.core-capabilities-row-3 {
  margin-top: 18px;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row.core-capabilities-row-3 .core-capabilities-item-content {
  position: static;
  padding-top: 36px;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row.core-capabilities-row-3 .core-capabilities-item-screenshot-img {
  object-position: 0 -45px;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row.core-capabilities-row-3 .corner-image-wrapper {
  width: 50%;
  top: 0;
  right: 0;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row.core-capabilities-row-4 {
  margin-top: 18px;
  display: flex;
  gap: 18px;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row.core-capabilities-row-4 .core-capabilities-col {
  width: 50%;
}
.compliance-page.isMobile .home-page-content .compliance-core-capabilities .core-capabilities-mobile-wrapper .core-capabilities-row.core-capabilities-row-4 .core-capabilities-col .core-capabilities-item-content {
  padding-top: 48px;
}
.compliance-page.isMobile .home-page-content .compliance-see-in-action {
  margin-top: 10px;
  padding: 40px 20px 20px 20px;
}
.compliance-page.isMobile .home-page-content .compliance-see-in-action .see-in-action-title {
  font-weight: 400;
  font-size: 32px;
  line-height: 120%;
  text-align: center;
}
.compliance-page.isMobile .home-page-content .compliance-see-in-action .see-in-action-images-wrapper {
  flex-wrap: wrap;
  margin-top: 36px;
  justify-content: center;
}
.compliance-page.isMobile .home-page-content .compliance-see-in-action .see-in-action-images-wrapper .see-in-action-image-wrapper {
  flex-basis: 100%;
}
.compliance-page.isMobile .home-page-content .compliance-see-in-action .see-in-action-images-wrapper .see-in-action-image-wrapper .see-in-action-img {
  width: 276px;
  height: 276px;
}
.compliance-page.isMobile .home-page-content .compliance-core-benefits {
  margin-top: 10px;
  padding: 40px 20px 20px 20px;
}
.compliance-page.isMobile .home-page-content .compliance-core-benefits .compliance-core-benefits-title {
  font-weight: 400;
  font-size: 32px;
  line-height: 120%;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/subpages/Compliance/styles.scss"],"names":[],"mappings":"AAEI;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,yDAAA;EACA,mBAAA;AADN;AAGM;EACE,UAAA;EACA,YAAA;EACA,4BAAA;EACA,+BAAA;EACA,4BAAA;EACA,WAAA;AADR;AAGQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AADV;AAGU;EACE,cAAA;AADZ;AAKQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAHV;AAMQ;EACE,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,4BAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,4DAAA;EACA,6DAAA;AAJV;AAQM;EACE,YAAA;EACA,kBAAA;EACA,UAAA;AANR;AAQQ;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,6BAAA;EACA,gCAAA;AANV;AASQ;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,2EAAA;EACA,6BAAA;EACA,gCAAA;EACA,oBAAA;AAPV;AAYI;EACE,oBAAA;EACA,aAAA;AAVN;AAYM;EACE,yBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AAVR;AAYQ;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAVV;AAaQ;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAXV;AAeM;EACE,UAAA;AAbR;AAeQ;EACE,WAAA;AAbV;AAeU;EACE,gBAAA;EACA,kBAAA;EACA,8BAAA;EACA,4DAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAbZ;AAeY;EACE,aAAA;AAbd;AAgBY;EACE,kBAAA;EACA,iBAAA;AAdd;AAiBY;EACE,kBAAA;EACA,iBAAA;AAfd;AAkBY;EACE,iBAAA;EACA,iBAAA;AAhBd;AAuBI;EACE,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;AArBN;AAuBM;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AArBR;AAwBM;EACE,aAAA;EACA,sCAAA;EACA,SAAA;EACA,gBAAA;AAtBR;AAwBQ;EACE,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,mBAAA;EACA,wMAAA;AAtBV;AAyBU;EACE,gBAAA;AAvBZ;AA0BU;EACE,mBAAA;AAxBZ;AA2BU;EACE,mBAAA;AAzBZ;AA4BU;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,iBAAA;AA1BZ;AA4BY;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AA1Bd;AA8BU;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AA5BZ;AA8BY;EACE,yBAAA;AA5Bd;AAgCU;EACE,kBAAA;AA9BZ;AAgCY;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA9Bd;AAiCY;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA/Bd;AAmCU;EACE,YAAA;AAjCZ;AAmCY;EACE,UAAA;AAjCd;AAoCY;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;AAlCd;AAsCU;EACE,YAAA;EACA,aAAA;EACA,SAAA;AApCZ;AAsCY;EACE,uBAAA;AApCd;AAuCY;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;AArCd;AAwCY;EACE,uBAAA;AAtCd;AA6CI;EACE,yBAAA;EACA,yDAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gCAAA;AA3CN;AA6CM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AA3CR;AA8CM;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AA5CR;AA8CQ;EACE,SAAA;EACA,gBAAA;EACA,kBAAA;AA5CV;AA8CU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AA5CZ;AA+CU;EACE,kBAAA;EACA,aAAA;EACA,YAAA;AA7CZ;AAiDY;EACE,0BAAA;AA/Cd;AAoDY;EACE,qBAAA;AAlDd;AAyDI;EACE,+BAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;AAvDN;AAyDM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,0BAAA;AAvDR;AA0DM;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AAxDR;AA2DM;EACE,gBAAA;AAzDR;AA2DQ;EACE,oBAAA;AAzDV;AA2DU;;EAEE,aAAA;AAzDZ;AA4DU;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AA1DZ;AA6DU;EACE,mBAAA;AA3DZ;AA+DQ;EACE,aAAA;EACA,8BAAA;AA7DV;AA+DU;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,yCAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;AA7DZ;AA8DY;EACE,yBAAA;AA5Dd;AAiEQ;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AA/DV;AAiEU;EACE,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AA/DZ;AAiEY;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA/Dd;AAmEU;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjEZ;;AA2EI;EACE,yDAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;AAxEN;AA0EM;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;AAxER;AA0EQ;EACE,eAAA;AAxEV;AA2EQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAzEV;AA4EQ;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;AA1EV;AA+EI;EACE,4BAAA;EACA,cAAA;AA7EN;AA+EM;EACE,WAAA;EACA,UAAA;AA7ER;AA+EQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AA7EV;AAiFM;EACE,gBAAA;EACA,WAAA;AA/ER;AAkFU;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;AAhFZ;AAsFI;EACE,kBAAA;AApFN;AAsFM;EACE,eAAA;AApFR;AAuFM;EACE,gBAAA;AArFR;AAwFU;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,kBAAA;EACA,sMAAA;EAGA,yBAAA;EACA,mBAAA;AAxFZ;AA2Fc;EACE,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,4DAAA;EACA,6DAAA;EACA,YAAA;EACA,aAAA;AAzFhB;AA6FY;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;AA3Fd;AA6Fc;EACE,WAAA;AA3FhB;AA+FY;EACE,YAAA;EACA,4BAAA;EACA,kBAAA;EACA,UAAA;AA7Fd;AA+Fc;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA7FhB;AAgGc;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA9FhB;AAmGU;EACE,gBAAA;EACA,aAAA;EACA,SAAA;AAjGZ;AAmGY;EACE,UAAA;AAjGd;AAmGc;EACE,iBAAA;AAjGhB;AAsGU;EACE,gBAAA;AApGZ;AAsGY;EACE,gBAAA;EACA,iBAAA;AApGd;AAuGY;EACE,UAAA;EACA,MAAA;EACA,QAAA;AArGd;AAyGU;EACE,gBAAA;AAvGZ;AAyGY;EACE,gBAAA;EACA,iBAAA;AAvGd;AA0GY;EACE,wBAAA;AAxGd;AA2GY;EACE,UAAA;EACA,MAAA;EACA,QAAA;AAzGd;AA6GU;EACE,gBAAA;EACA,aAAA;EACA,SAAA;AA3GZ;AA6GY;EACE,UAAA;AA3Gd;AA6Gc;EACE,iBAAA;AA3GhB;AAmHI;EACE,gBAAA;EACA,4BAAA;AAjHN;AAmHM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAjHR;AAoHM;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AAlHR;AAoHQ;EACE,gBAAA;AAlHV;AAoHU;EACE,YAAA;EACA,aAAA;AAlHZ;AAwHI;EACE,gBAAA;EACA,4BAAA;AAtHN;AAwHM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAtHR","sourcesContent":[".compliance-page {\n  .home-page-content {\n    .simplify-compliance {\n      display: flex;\n      margin-top: 22px;\n      height: 530px;\n      background-image: url('../../../../assets/images/home/compliance-header-bg.png');\n      border-radius: 20px;\n\n      .simplify-compliance-left {\n        width: 47%;\n        height: 100%;\n        border-top-left-radius: 20px;\n        border-bottom-left-radius: 20px;\n        padding: 100px 0 100px 100px;\n        color: #fff;\n\n        .simplify-compliance-title {\n          font-size: 48px;\n          font-weight: 600;\n          line-height: 120%;\n\n          .blue-part {\n            color: #a5c7ff;\n          }\n        }\n\n        .simplify-compliance-subtitle {\n          font-size: 22px;\n          margin-top: 24px;\n          line-height: 180%;\n        }\n\n        .request-demo-btn {\n          margin-top: 46px;\n          background-color: #fff;\n          border: none;\n          border-bottom: 2px solid #dee1e7;\n          border-radius: 8px;\n          padding: 12px 24px 12px 24px;\n          gap: 8px;\n          display: flex;\n          align-items: center;\n          width: 200px;\n          height: 46px;\n          color: #448aff;\n          font-weight: 600;\n          box-shadow: 0px 6px 10px -4px #0f17281a;\n          box-shadow: 0px 18px 32px -4px #0f172838;\n        }\n      }\n\n      .simplify-compliance-right {\n        height: 100%;\n        position: relative;\n        width: 57%;\n\n        .simplify-compliance-image {\n          height: 100%;\n          width: 100%;\n          object-fit: cover;\n          border-top-right-radius: 20px;\n          border-bottom-right-radius: 20px;\n        }\n\n        &::before {\n          content: '';\n          position: absolute;\n          top: 0;\n          left: 0;\n          height: 100%;\n          width: 100%;\n          background: linear-gradient(90deg, #3571d6 0%, rgba(53, 113, 214, 0) 39.9%);\n          border-top-right-radius: 20px;\n          border-bottom-right-radius: 20px;\n          pointer-events: none; // allows clicks to pass through\n        }\n      }\n    }\n\n    .manual-process {\n      padding: 120px 100px;\n      display: flex;\n\n      .manual-process-left-block {\n        padding: 44px 32px 44px 0;\n        width: 44%;\n        display: flex;\n        align-items: center;\n\n        .say-goodbye-title {\n          color: #448aff;\n          font-weight: 400;\n          font-size: 40px;\n          line-height: 120%;\n        }\n\n        .say-goodbye-subtitle {\n          margin-top: 20px;\n          font-weight: 400;\n          font-size: 20px;\n          line-height: 180%;\n        }\n      }\n\n      .manual-process-right-block {\n        width: 56%;\n\n        .manual-process-list {\n          width: 100%;\n\n          .manual-process-list-item {\n            min-height: 60px;\n            padding: 12px 24px;\n            border-left: 2px solid #a5c7ff;\n            background: linear-gradient(90deg, #e7f0ff 0%, #ffffff 100%);\n            margin-top: 12px;\n            font-size: 20px;\n            font-weight: 600;\n            line-height: 180%;\n            color: #040e46;\n\n            &:nth-child(1) {\n              margin-top: 0;\n            }\n\n            &:nth-child(2) {\n              margin-right: 68px;\n              margin-left: 30px;\n            }\n\n            &:nth-child(3) {\n              margin-right: 38px;\n              margin-left: 60px;\n            }\n\n            &:nth-child(4) {\n              margin-right: 8px;\n              margin-left: 90px;\n            }\n          }\n        }\n      }\n    }\n\n    .compliance-core-capabilities {\n      padding: 80px;\n      background-color: #e7f0ff;\n      border: 1px solid #eceef1;\n      border-radius: 20px;\n\n      .core-capabilities-title {\n        font-size: 40px;\n        line-height: 120%;\n        color: #3571d6;\n        text-align: center;\n      }\n\n      .core-capabilities-grid-container {\n        display: grid;\n        grid-template-columns: repeat(12, 1fr);\n        gap: 32px;\n        margin-top: 46px;\n\n        .core-capabilities-item {\n          position: relative;\n          min-height: 260px;\n          padding: 112px 36px 36px 36px;\n          grid-column: span 4;\n          background: linear-gradient(0deg, var(--Greyscale-Grey-5, #f9fafb), var(--Greyscale-Grey-5, #f9fafb)),\n            radial-gradient(50% 161.19% at 50% 100%, rgba(68, 138, 255, 0) 50%, rgba(68, 138, 255, 0.1) 100%);\n\n          &.core-capabilities-item-tall {\n            grid-row: span 2;\n          }\n\n          &.core-capabilities-item-wide {\n            grid-column: span 8;\n          }\n\n          &.core-capabilities-item-semi-wide {\n            grid-column: span 6;\n          }\n\n          .corner-image-wrapper {\n            position: absolute;\n            right: 0;\n            top: 0;\n            text-align: right;\n\n            svg {\n              position: absolute;\n              top: 42px;\n              right: 42px;\n            }\n          }\n\n          .core-capabilities-item-screenshot-img {\n            width: 100%;\n            height: 260px;\n            background-size: cover;\n            position: relative;\n            z-index: 2;\n            object-fit: cover;\n            border-radius: 4px;\n\n            &.capabilities-drill-screenshot {\n              object-position: 0 -150px;\n            }\n          }\n\n          .core-capabilities-item-content {\n            position: relative;\n\n            .core-capabilities-item-title {\n              color: #040e46;\n              font-size: 26px;\n              font-weight: 600;\n              line-height: 130%;\n            }\n\n            .core-capabilities-item-subtitle {\n              margin-top: 12px;\n              font-weight: 400;\n              font-size: 18px;\n              line-height: 150%;\n            }\n          }\n\n          &:nth-child(3) {\n            padding: 6px;\n\n            .corner-image-wrapper {\n              top: 215px;\n            }\n\n            .core-capabilities-item-content {\n              margin-top: 112px;\n              margin-left: 36px;\n              margin-right: 36px;\n            }\n          }\n\n          &:nth-child(4) {\n            padding: 6px;\n            display: flex;\n            gap: 32px;\n\n            .core-capabilities-item-screenshot-wrapper {\n              width: calc(50% - 16px);\n            }\n\n            .core-capabilities-item-content {\n              margin-top: 112px;\n              margin-left: 36px;\n              margin-right: 36px;\n            }\n\n            .core-capabilities-item-right-block {\n              width: calc(50% - 16px);\n            }\n          }\n        }\n      }\n    }\n\n    .compliance-see-in-action {\n      background-color: #3571d6;\n      background-image: url('../../../../assets/images/home/operations-bg.svg');\n      padding: 60px;\n      border-radius: 20px;\n      background-size: cover;\n      margin-top: 20px;\n      padding: 100px 100px 120px 100px;\n\n      .see-in-action-title {\n        font-size: 40px;\n        font-weight: 400;\n        color: #fff;\n        text-align: center;\n      }\n\n      .see-in-action-images-wrapper {\n        display: flex;\n        gap: 32px;\n        margin-top: 80px;\n\n        .see-in-action-image-wrapper {\n          flex: 1;\n          max-width: 276px;\n          position: relative;\n\n          .see-in-action-img {\n            width: 100%;\n            height: 100%;\n            max-height: 276px;\n            object-fit: cover;\n            border-radius: 10px;\n          }\n\n          .scale-icon {\n            position: absolute;\n            bottom: -41px;\n            right: -22px;\n          }\n\n          &:nth-child(1) {\n            .see-in-action-img {\n              object-position: 0px -35px;\n            }\n          }\n\n          &:nth-child(3) {\n            .see-in-action-img {\n              object-position: left;\n            }\n          }\n        }\n      }\n    }\n\n    .compliance-core-benefits {\n      padding: 135px 100px 80px 100px;\n      width: 100%;\n      margin-top: 20px;\n      border-radius: 20px;\n      overflow: hidden;\n      position: relative;\n      z-index: 1;\n      border: 1px solid #eceef1;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background-image: url('../../../../assets/images/home/hero-bg.png');\n        background-size: cover;\n        background-repeat: no-repeat;\n        background-position: center;\n        opacity: 0.35;\n        z-index: 0;\n        border-radius: 20px;\n        mix-blend-mode: luminosity;\n      }\n\n      .compliance-core-benefits-title {\n        color: #000;\n        font-size: 40px;\n        text-align: center;\n      }\n\n      .compliance-core-benefits-slider {\n        margin-top: 80px;\n\n        .swiper {\n          padding-bottom: 3rem;\n\n          .swiper-button-next,\n          .swiper-button-prev {\n            display: none;\n          }\n\n          .swiper-pagination-bullet {\n            background: #fff;\n            width: 10px;\n            height: 10px;\n            opacity: 1;\n          }\n\n          .swiper-pagination-bullet-active {\n            background: #4b6fff;\n          }\n        }\n\n        .custom-nav {\n          display: flex;\n          justify-content: space-between;\n\n          button {\n            position: relative;\n            z-index: 10;\n            width: 48px;\n            height: 48px;\n            border-radius: 50%;\n            background-color: #fff;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border: none;\n            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n            cursor: pointer;\n            transition: all 0.2s;\n            color: #3571d6;\n            &:hover {\n              background-color: #f5f5f5;\n            }\n          }\n        }\n\n        .compliance-core-benefits-slide {\n          position: relative;\n          border-radius: 1rem;\n          text-align: center;\n          height: 230px;\n\n          .compliance-core-benefits-slide-content {\n            background-color: #fff;\n            border-radius: 10px;\n            height: 200px;\n            padding: 80px 28px;\n\n            .compliance-core-benefits-title {\n              color: #3571d6;\n              font-size: 28px;\n              font-weight: 600;\n              line-height: 130%;\n            }\n          }\n\n          .icon-wrapper {\n            position: absolute;\n            top: 0;\n            left: 50%;\n            transform: translate(-50%, 0);\n            height: 90px;\n            width: 90px;\n            background-color: #3571d6;\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n          }\n        }\n      }\n    }\n  }\n}\n\n.compliance-page.isMobile {\n  .home-page-content {\n    .simplify-compliance {\n      background-image: url('../../../../assets/images/home/compliance-header-mobile-bg.png');\n      background-size: cover;\n      margin-top: 37px;\n      height: unset;\n\n      .simplify-compliance-left {\n        padding: 0 20px 20px 20px;\n        margin-top: 240px;\n        width: 100%;\n\n        .simplify-compliance-title {\n          font-size: 32px;\n        }\n\n        .simplify-compliance-subtitle {\n          font-size: 20px;\n          margin-top: 16px;\n          line-height: 160%;\n        }\n\n        .request-demo-btn {\n          margin-top: 28px;\n          width: 100%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          font-size: 16px;\n          line-height: 150%;\n        }\n      }\n    }\n\n    .manual-process {\n      padding: 40px 20px 40px 20px;\n      display: block;\n\n      .manual-process-left-block {\n        width: 100%;\n        padding: 0;\n\n        .say-goodbye-title {\n          font-weight: 400;\n          font-size: 32px;\n          line-height: 120%;\n        }\n      }\n\n      .manual-process-right-block {\n        margin-top: 18px;\n        width: 100%;\n\n        .manual-process-list {\n          .manual-process-list-item {\n            font-weight: 600;\n            font-size: 18px;\n            line-height: 120%;\n            min-height: unset;\n            margin-left: 0 !important;\n            margin-right: 0 !important;\n            margin-top: 10px !important;\n          }\n        }\n      }\n    }\n\n    .compliance-core-capabilities {\n      padding: 40px 20px;\n\n      .core-capabilities-title {\n        font-size: 32px;\n      }\n\n      .core-capabilities-mobile-wrapper {\n        margin-top: 46px;\n\n        .core-capabilities-row {\n          .core-capabilities-col {\n            padding: 6px;\n            display: flex;\n            gap: 8px;\n            position: relative;\n            background: radial-gradient(100% 157.58% at 0% 100%, rgba(68, 138, 255, 0.1) 0%, rgba(68, 138, 255, 0) 50%),\n              linear-gradient(0deg, var(--Greyscale-Grey-5, #f9fafb), var(--Greyscale-Grey-5, #f9fafb));\n\n            border: 1px solid #f9fafb;\n            border-radius: 10px;\n\n            .core-capabilities-item-screenshot-wrapper {\n              .core-capabilities-item-screenshot-img {\n                object-fit: cover;\n                border-radius: 4px;\n                border: 1px solid #fff;\n                box-shadow: 0px 6px 10px -4px #0f17281a;\n                box-shadow: 0px 18px 32px -4px #0f172838;\n                width: 130px;\n                height: 132px;\n              }\n            }\n\n            .corner-image-wrapper {\n              width: 100%;\n              position: absolute;\n              top: 0;\n              right: 0;\n\n              .corner-image {\n                width: 100%;\n              }\n            }\n\n            .core-capabilities-item-content {\n              flex-grow: 1;\n              padding: 74px 12px 12px 12px;\n              position: relative;\n              z-index: 2;\n\n              .core-capabilities-item-title {\n                font-weight: 600;\n                font-size: 16px;\n                line-height: 130%;\n                color: #040e46;\n              }\n\n              .core-capabilities-item-subtitle {\n                margin-top: 6px;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 130%;\n              }\n            }\n          }\n\n          &.core-capabilities-row-1 {\n            margin-top: 18px;\n            display: flex;\n            gap: 18px;\n\n            .core-capabilities-col {\n              width: 50%;\n\n              .core-capabilities-item-content {\n                padding-top: 48px;\n              }\n            }\n          }\n\n          &.core-capabilities-row-2 {\n            margin-top: 18px;\n\n            .core-capabilities-item-content {\n              position: static;\n              padding-top: 36px;\n            }\n\n            .corner-image-wrapper {\n              width: 50%;\n              top: 0;\n              right: 0;\n            }\n          }\n\n          &.core-capabilities-row-3 {\n            margin-top: 18px;\n\n            .core-capabilities-item-content {\n              position: static;\n              padding-top: 36px;\n            }\n\n            .core-capabilities-item-screenshot-img {\n              object-position: 0 -45px;\n            }\n\n            .corner-image-wrapper {\n              width: 50%;\n              top: 0;\n              right: 0;\n            }\n          }\n\n          &.core-capabilities-row-4 {\n            margin-top: 18px;\n            display: flex;\n            gap: 18px;\n\n            .core-capabilities-col {\n              width: 50%;\n\n              .core-capabilities-item-content {\n                padding-top: 48px;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .compliance-see-in-action {\n      margin-top: 10px;\n      padding: 40px 20px 20px 20px;\n\n      .see-in-action-title {\n        font-weight: 400;\n        font-size: 32px;\n        line-height: 120%;\n        text-align: center;\n      }\n\n      .see-in-action-images-wrapper {\n        flex-wrap: wrap;\n        margin-top: 36px;\n        justify-content: center;\n\n        .see-in-action-image-wrapper {\n          flex-basis: 100%;\n\n          .see-in-action-img {\n            width: 276px;\n            height: 276px;\n          }\n        }\n      }\n    }\n\n    .compliance-core-benefits {\n      margin-top: 10px;\n      padding: 40px 20px 20px 20px;\n\n      .compliance-core-benefits-title {\n        font-weight: 400;\n        font-size: 32px;\n        line-height: 120%;\n        text-align: center;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
